/* global location */

import './trials.css';

import React, { Component, PropTypes } from 'react';
import { Link, hashHistory } from 'react-router';
import Icon from '../components/Icon';

import { conditions } from '../services/content';
import lang from '../services/lang';
import FetchPlease from 'fetch-please';
import { API_URI } from '../services/config';
const search = new FetchPlease(`${API_URI}/trials/search`);
const fetchByCondtition = new FetchPlease(`${API_URI}/trials`);
import { beep, ding } from '../services/audio';
import { trackView } from '../services/analytics';


function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return "";
}


export default class Trials extends Component {
  
  state = {
    count: 0,
    trials: [],
    isLoading: true,
  }
  
  componentDidMount() {
    this.setState({isLoading:true});
    
    let query = null;

    console.log(window.location);
    
    if(this.props.params.id) {
      query = fetchByCondtition.get(`?conditions=${this.props.params.id}` + "&recruitingStatus=RECRUITING&serviceLineId=Cancer&limit=100");
    }
    else {
      const queryParams = location.hash.slice( location.hash.indexOf('?') );
      console.log(location.hash, queryParams);
      query = search.get(queryParams + "&recruitingStatus=RECRUITING&serviceLineId=Cancer&condition=Cancer&limit=100");
    }
    
    query
      .then(res => {
        this.setState({...res, isLoading:false});
      });
    
    beep();

    trackView("Search Results");
  }
  
  componentWillUnmount() {
    search.abort();
    fetchByCondtition.abort();
  }
  
  renderTrial = trial => {
    return (
      <article key={trial.id} className="trials-trial-listitem">
        <Link to={`/trial/${trial.id}`} key={trial.id}>
          <span className="trials-results-icon"></span>
          <div className="trials-text">
            <h3>{trial.studyTitle}</h3>
            {trial.investigators && <p>Principal Investigator: {trial.investigators[0].displayName}</p>}
          </div>
        </Link>
      </article>
    );
  }
  
  renderTrials() {
    return this.state.trials.map(this.renderTrial);
  }
  
  renderMenu() {
    return (
      <div>
        <div className="trials-menu">
          <div className="trial-menu-back" onClick={hashHistory.goBack}>
            <h5 className="trial-menu-subtitle"> <Icon name="prev" className="trial-menu-back-icon"/> Find Trials</h5>
          </div>
          <Link to="/menu" className="trials-menu-main">
            {lang('main-menu')} <Icon name="menuWhite" className="trials-menu-main-icon"/>
          </Link>
        </div>
        
        <div className="trials-menu-mobile">
          <div className="trials-menu-back" onClick={hashHistory.goBack}>
            <Icon name="prev" className="trials-menu-back-icon"/>
          </div>
          <h5 className="trials-menu-subtitle">Find Trials</h5>
        </div>
      </div>
    );
  }
  
  render() {
    const { count, isLoading } = this.state;
    
    if(isLoading) {
      return (
        <div className="trials">
          <div className="trials-loader"> Loading </div>
        </div>
      );
    }
    
    let title = ""; 
    
    if(this.props.params.id) {
      let id = this.props.params.id;
      
      for(let c in conditions) {
        if(conditions[c].id == id) {
          title = conditions[c].description.trim();
        }
        
        for(let sc in conditions[c].subConditions) {
          if(conditions[c].subConditions[sc].id == id) {
            title = conditions[c].subConditions[sc].description.trim();
          }
        }
      }
    }
    else if(getQueryVariable('keyword')) {
      title = getQueryVariable('keyword');
    }
    else if(getQueryVariable('studyPhase')) {
      const phases = {
        'Phase_0': 'Early Phase 1',
        'Phase_1': 'Phase 1',
        'Phase_1_Phase_2': 'Phase 1 / Phase 2',
        'Phase_2': 'Phase 2',
        'Phase_2_Phase_3': 'Phase 2 / Phase 3',
        'Phase_3': 'Phase 3',
        'Phase_4': 'Phase 4',
      };
      title = phases[getQueryVariable('studyPhase')];
    }
    
    if(count == 0) {
      return (
        <div className="trials">
          <div className="trials-title">
            <h1 className="trials-results-title">{!!title ? `Trials for '${title}'` : "Trials"}</h1>
            <h3 className="trials-results-subtitle">No trials found.</h3>
          </div>
          
          <section className="trials-results"></section>
          
          {this.renderMenu()}
          
        </div>
      );
    }
    
    return (
      <div className="trials">
        
        <div className="trials-title">
          <h1 className="trials-results-title">{!!title ? `Trials for '${title}'` : "Trials"}</h1>
          <h3 className="trials-results-subtitle">Found {this.state.trials.length} Trials</h3>
          
          <Link className="trials-button" to="/subscription">New Trial Alerts</Link>
          {/*<h3 className="trials-results-subscribe">Receive email alerts when trials open to patients! <Link to="/subscription">Sign up here.</Link></h3>*/}
        </div>
        
        <section className="trials-results">
          {this.renderTrials()} 
        </section>
        
        {this.renderMenu()}
        
      </div>
      
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Trials.js